import React, { useState } from 'react';
import { Link } from '@mui/material';
import { Menu } from 'lucide-react';
import { X } from 'lucide-react';
import navigationData from './Navigation.json'

import CompanyName from './CompanyName'

const Navigation = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="bg-[#06070E] text-white">
            <div className="container mx-auto flex items-center justify-between py-4 px-6">
                {/* Logo */}
                <div className="text-xl  newsreader-bagdad">
                    <Link href="/Home" style={{ color: '#DAA520', textDecoration: 'none', fontWeight: 'bold', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
                        <CompanyName />
                    </Link>
                </div>

                {/* Hamburger Icon */}
                <button style={{ textShadow: '4px 4px 8px rgba(0, 0, 0, 0.8)' }}
                    className="text-2xl lg:hidden focus:outline-none text-[#DAA520]"
                    onClick={toggleMenu}
                >
                    {isOpen ? <X /> : <Menu />}
                </button>

                {/* Links for Large Screens */}
                <ul className="hidden lg:flex lg:items-center lg:space-x-6">
                    {navigationData.map((link) => (
                        <li key={link.title} className="group relative">
                            <Link
                                href={link.url}
                                style={{ color: '#C9E1E3' }}
                                className="font-bold"
                            >
                                {link.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Links for Mobile Screens */}
            <ul className={`lg:hidden bg-[#102E4A] ${isOpen ? 'block' : 'hidden'}`}>
                {navigationData.map((link) => (
                    <li key={link.title} className="py-2 px-6">
                        <Link
                            href={link.url}
                            style={{ color: '#C9E1E3' }}
                            className="font-bold"
                        >
                            {link.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Navigation;

// import React, { useState } from 'react';
// import { styled, useTheme } from '@mui/material/styles';
// import { AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemText, Divider } from '@mui/material';
// import { Menu as MenuIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
// import { Link } from '@mui/material';
// import Button from '@mui/material/Button';
// import Logo from '../Images/Ares-Custom-Yachts.png';
// import Open from './Open';
// import PhoneIcon from '@mui/icons-material/Phone';
// import SlideShow from './SlideShow';



// const drawerWidth = 320;

// const Main = styled('main')(({ theme, open }) => ({
//     flexGrow: 1,
//     transition: theme.transitions.create('margin', {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//     }),
//     marginLeft: 0,
//     ...(open && {
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.easeOut,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//         marginLeft: drawerWidth,
//     }),
// }));

// const DrawerHeader = styled('div')(({ theme }) => ({
//     display: 'flex',

//     alignItems: 'center',
//     justifyContent: 'flex-end',
//     padding: theme.spacing(0, 1),
//     ...theme.mixins.toolbar,
// }));

// const Navigation = ({ children }) => {
//     const theme = useTheme();
//     const [open, setOpen] = useState(false);

//     const handleDrawerOpen = () => {
//         setOpen(true);
//     };

//     const handleDrawerClose = () => {
//         setOpen(false);
//     };

//     const phoneNumber = '9546462797';

//     const handlePhoneClick = () => {
//         window.location.href = 'tel:' + phoneNumber;
//     };

//     return (
//         <div>
//             <AppBar position="fixed" open={open} sx={{ color: '#104895', backgroundColor: '#ffffff' }}>
//                 <Toolbar className=''>
//                     <IconButton
//                         color="inherit"
//                         aria-label="open drawer"
//                         onClick={handleDrawerOpen}
//                         edge="start"
//                         sx={{ mr: 2, ...(open && { display: 'none' }) }}
//                         className='text-[#DB5726] print:invisible'
//                     >
//                         <MenuIcon />
//                     </IconButton>
//                     {/* <div component="div">
//                         <Link href='/'><img src={Logo} alt='' className='w-[100px]' /></Link>
//                     </div> */}

//                     <div style={{ flexGrow: 1 }} />



//


//                 </Toolbar>

//             </AppBar>

//             <Drawer
//                 sx={{
//                     width: drawerWidth,
//                     flexShrink: 0,
//                     '& .MuiDrawer-paper': {
//                         width: drawerWidth,
//                         backgroundColor: 'transparent'
//                     },
//                 }}
//                 variant="persistent"
//                 anchor="left"
//                 open={open}
//             >
//                 <DrawerHeader>
//                     <IconButton onClick={handleDrawerClose} >
//                         {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//                     </IconButton>
//                 </DrawerHeader>
//                 <Divider />
//                 <List className='text-[#104895]'>
//                     {[
//                         { text: 'Home', link: '/', title: "" },
//                         { text: 'About Us', link: '/', title: "" },
//                         { text: 'Project History', link: '/History', title: "" },
//                         { text: 'Management Team', link: '/', title: "" },
//                         { text: 'Investors', link: '/', title: "" },
//                         { text: 'Deposit', link: '/BagdadChaseDeposit', title: "" },
//                         { text: 'Contact', link: '/', title: "" },


//                     ].map(({ text, link, title }) => (
//                         <ListItem key={text} sx={{ '&:hover': { color: '#DB5726', fontWeight: 'bold' } }} divider >
//                             <Link href={link} style={{ fontWeight: 'bold' }} color="text-[#104895]" underline="none" title={title}>

//                                 <ListItemText primary={<span style={{ fontWeight: 'bold' }}>{text}</span>} />
//                             </Link>

//                         </ListItem>
//                     ))}
//                 </List>
//             </Drawer>

//             <Main open={open}>
//                 <DrawerHeader />
//                 {/* <SlideShow /> */}
//                 {children}
//             </Main>

//         </div>
//     );
// };

// export default Navigation;